
import { DisenioPaginas } from '../../layout';
import { FormCreateUpdateUser } from '../../components';






export const CrearUsuarios = () => {

    const initialState = {
        nombre: "",
        cedula: '',
        email: "",
        role: "",
        direccion: "",
        departamento: "",
        ciudad: "",
        movil: "",
    };


    return (

        <DisenioPaginas titulo="Crear Usuario" url={1} add={false} subtitulo="Información del usuario">
            <FormCreateUpdateUser initialState={initialState} />
        </DisenioPaginas>

    )
}
